import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTop() {
  const { pathname, search, hash } = useLocation();
  
  useEffect(() => {
    // Don't scroll to top if URL has type parameter (for find owner functionality)
    const urlParams = new URLSearchParams(search);
    const hasTypeParam = urlParams.has('type');
    
    if (hasTypeParam) return;

    const id = hash?.replace(/^#/, '');
    if (id) {
      const decoded = decodeURIComponent(id);
      setTimeout(() => {
        document.getElementById(decoded)?.scrollIntoView({ behavior: 'smooth' });
      }, 100);
      return;
    }

    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 100);
  }, [pathname, search, hash]);
  
  return null;
}
